import { render } from "./accountMa.vue?vue&type=template&id=6b247d5c&scoped=true"
import script from "./accountMa.vue?vue&type=script&lang=js"
export * from "./accountMa.vue?vue&type=script&lang=js"

import "./accountMa.vue?vue&type=style&index=0&id=6b247d5c&lang=scss&scoped=true"

import exportComponent from "/data/jenkins-workspace/workspace/Publicar_automáticamente_por_Lianxin/联心运营后台前端【生产】/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b247d5c"]])

export default __exports__